/*
 * Public API Surface of websocket
 */

export * from './websocket.module';
export * from './services/web-socket.service';
export * from './services/testing-websocket.service';
export * from './providers/web-socket-connection.provider';
export * from './interfaces/websocket-provider.interface';
export * from './configs/websocket.config';
